/**
 *
 * Asynchronously loads the component for ProductCreate
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ProductCreate = lazyLoad(
  () => import('./index'),
  module => module.default,
);
